// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"7iPcf":[function(require,module,exports,__globalThis) {
/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSchedules", ()=>getSchedules);
parcelHelpers.export(exports, "getNearestScheduleSlug", ()=>getNearestScheduleSlug);
var _graphqlService = require("../services/graphqlService");
var _slugify = require("./slugify");
let cachedSchedules = null;
const getSchedules = async ()=>{
    if (cachedSchedules) return cachedSchedules;
    try {
        var _data_data_connectScheduleList, _data_data;
        const data = await (0, _graphqlService.fetchSchedule)();
        const schedules = (data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : (_data_data_connectScheduleList = _data_data.connectScheduleList) === null || _data_data_connectScheduleList === void 0 ? void 0 : _data_data_connectScheduleList.items) || [];
        cachedSchedules = schedules.filter((s)=>s.title && s.date).map((s)=>({
                slug: s.slug || (0, _slugify.createSlug)(s.title),
                // Use slug from GraphQL or generate from title
                date: new Date(s.date),
                title: s.title
            })).sort((a, b)=>a.date - b.date);
        return cachedSchedules;
    } catch (err) {
        console.error('Failed to fetch schedules:', err);
        return [];
    }
};
const getNearestScheduleSlug = async ()=>{
    const schedules = await getSchedules();
    if (schedules.length === 0) // Fallback to home if no schedules found
    return '';
    const today = new Date();
    // Find schedule with smallest time difference
    let nearest = schedules[0];
    let minDiff = Math.abs(today - schedules[0].date);
    for (const schedule of schedules){
        const diff = Math.abs(today - schedule.date);
        if (diff < minDiff) {
            minDiff = diff;
            nearest = schedule;
        }
    }
    return nearest.slug;
};

},{"../services/graphqlService":"9h2sF","./slugify":"lThz1","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"9h2sF":[function(require,module,exports,__globalThis) {
/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchSpeakers", ()=>fetchSpeakers);
parcelHelpers.export(exports, "fetchSchedule", ()=>fetchSchedule);
parcelHelpers.export(exports, "fetchSessions", ()=>fetchSessions);
parcelHelpers.export(exports, "fetchGondolas", ()=>fetchGondolas);
parcelHelpers.export(exports, "fetchConsent", ()=>fetchConsent);
parcelHelpers.export(exports, "fetchGallerySections", ()=>fetchGallerySections);
parcelHelpers.export(exports, "fetchGallerySectionImages", ()=>fetchGallerySectionImages);
var _objectSpread = require("@swc/helpers/_/_object_spread");
const GRAPHQL_ENDPOINT = "https://publish-p133965-e1614727.adobeaemcloud.com/graphql/execute.json/ewsr";
const GRAPHQL_AUTH = undefined;
const ROOT_PATH = "/content/dam/ews/ewsr/connect/2026/cx-day-live";
const SPEAKER_ROOT_PATH = "/content/dam/ews/ewsr/connect,/content/dam/ews/cx-days,/content/dam/ews/content-fragments";
const runPersistedQuery = async (queryName, variables = {})=>{
    const headers = {};
    if (GRAPHQL_AUTH) headers['Authorization'] = `Basic ${GRAPHQL_AUTH}`;
    const allVars = (0, _objectSpread._)({
        rootPath: ROOT_PATH
    }, variables);
    let variablesString = encodeURIComponent(Object.keys(allVars).map((key)=>{
        const val = typeof allVars[key] === 'string' ? allVars[key] : JSON.stringify(allVars[key]);
        return `;${key}=${val}`;
    }).join(''));
    if (variablesString) variablesString += ';';
    const url = `${GRAPHQL_ENDPOINT}/${queryName}${variablesString}?t=${Math.floor(Date.now() / 300000)}`;
    const res = await fetch(url, {
        headers,
        cache: 'no-store'
    });
    if (!res.ok) throw new Error(`GraphQL error: ${res.status}`);
    return await res.json();
};
const fetchSpeakers = async ()=>{
    const data = await runPersistedQuery('getConnectSpeakers', {
        rootPath: SPEAKER_ROOT_PATH
    });
    return data;
};
const fetchSchedule = async ()=>{
    try {
        return await runPersistedQuery('getConnectSchedule');
    } catch (err) {
        console.warn('GraphQL schedule failed:', err);
        return {
            data: {
                connectScheduleList: {
                    items: []
                }
            }
        };
    }
};
const fetchSessions = async (speakerPath = null)=>{
    try {
        const variables = speakerPath ? {
            speakerPath
        } : {};
        return await runPersistedQuery('getConnectSession', variables);
    } catch (err) {
        console.warn('GraphQL sessions failed:', err);
        return {
            data: {
                connectSessionList: {
                    items: []
                }
            }
        };
    }
};
const fetchGondolas = async (schedulePath = null)=>{
    try {
        const variables = schedulePath ? {
            schedulePath
        } : {};
        return await runPersistedQuery('getConnectGondolas', variables);
    } catch (err) {
        console.warn('GraphQL gondolas failed:', err);
        return {
            data: {
                connectGondolaList: {
                    items: []
                }
            }
        };
    }
};
const fetchConsent = async ()=>{
    try {
        return await runPersistedQuery('getConnectConsent');
    } catch (err) {
        console.warn('GraphQL consent failed:', err);
        return {
            data: {
                connectConsentList: {
                    items: []
                }
            }
        };
    }
};
const fetchGallerySections = async ()=>{
    try {
        return await runPersistedQuery('getConnectGallerySections');
    } catch (err) {
        console.warn('GraphQL gallery sections failed:', err);
        return {
            data: {
                connectGallerySectionList: {
                    items: []
                }
            }
        };
    }
};
const fetchGallerySectionImages = async (sectionPath)=>{
    try {
        return await runPersistedQuery('getGallerySectionImages', {
            path: sectionPath
        });
    } catch (err) {
        console.warn('GraphQL gallery images failed:', err);
        return {
            data: {
                connectGallerySectionByPath: {
                    item: {
                        images: []
                    }
                }
            }
        };
    }
};

},{"@swc/helpers/_/_object_spread":"PGIdx","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"PGIdx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_spread);
var _definePropertyJs = require("./_define_property.js");
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, _definePropertyJs._)(target, key, source[key]);
        });
    }
    return target;
}

},{"./_define_property.js":"lqv4h","@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"lqv4h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_define_property);
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}],"1L3TO":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"lThz1":[function(require,module,exports,__globalThis) {
/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */ /**
 * Extract a unique gondola ID from an AEM _path.
 * Uses last 3 segments to ensure uniqueness across event days.
 * e.g. "/content/dam/ews/ewsr/connect/2026/cx-days/gondolas/serverless-apps"
 *   → "cx-days/gondolas/serverless-apps"
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGondolaId", ()=>getGondolaId);
parcelHelpers.export(exports, "getGondolaSlug", ()=>getGondolaSlug);
parcelHelpers.export(exports, "createSlug", ()=>createSlug);
parcelHelpers.export(exports, "findBySlug", ()=>findBySlug);
parcelHelpers.export(exports, "findByGondolaSlug", ()=>findByGondolaSlug);
const getGondolaId = (path)=>{
    if (!path) return '';
    const segments = path.split('/').filter(Boolean);
    return segments.slice(-3).join('/');
};
const getGondolaSlug = (gondola)=>{
    var _gondola_schedule;
    var _gondola_title;
    const base = createSlug((_gondola_title = gondola === null || gondola === void 0 ? void 0 : gondola.title) !== null && _gondola_title !== void 0 ? _gondola_title : '');
    const date = gondola === null || gondola === void 0 ? void 0 : (_gondola_schedule = gondola.schedule) === null || _gondola_schedule === void 0 ? void 0 : _gondola_schedule.date;
    if (!date) return base;
    const [, month, day] = date.split('-');
    return `${base}-${day}-${month}`;
};
const createSlug = (text)=>{
    return text.toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
};
const findBySlug = (items, slug, titleField = 'title')=>{
    return items.find((item)=>createSlug(item[titleField]) === slug);
};
const findByGondolaSlug = (gondolas, slug)=>{
    return gondolas.find((g)=>getGondolaSlug(g) === slug);
};
// CommonJS export for tests
if (module.exports) module.exports = {
    createSlug,
    findBySlug,
    getGondolaId,
    getGondolaSlug,
    findByGondolaSlug
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"1L3TO"}]},[], null, "parcelRequire33b7", {})

//# sourceMappingURL=scheduleUtils.84ab0cca.js.map
